/* LNGVTY PDP v2 — shared behaviour for lv2-* sections */
(function () {
  'use strict';
  if (window.__lv2Init) return;
  window.__lv2Init = true;

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- reveal on scroll ---------- */
  function initReveal() {
    var els = $$('.lv2 [data-lv-reveal]');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- gallery ---------- */
  function initGallery(root) {
    var track = $('.lv2-gal__track', root);
    if (!track) return;
    var slides = $$('.lv2-gal__slide', track);
    var thumbs = $$('.lv2-gal__thumb', root);
    var bar = $('.lv2-gal__bar i', root);
    var n = slides.length || 1;
    if (bar) bar.style.setProperty('--w', (100 / n) + '%');
    function idx() { return Math.round(track.scrollLeft / track.clientWidth); }
    function go(i) { i = (i + n) % n; track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); }
    function sync() {
      var i = idx();
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      if (bar) bar.style.setProperty('--x', (i * 100) + '%');
    }
    var t; track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(sync, 60); }, { passive: true });
    thumbs.forEach(function (th, k) { th.addEventListener('click', function () { go(k); }); });
    var prev = $('[data-gal-prev]', root), next = $('[data-gal-next]', root);
    if (prev) prev.addEventListener('click', function () { go(idx() - 1); });
    if (next) next.addEventListener('click', function () { go(idx() + 1); });
    root.__lv2Go = function (mediaId) {
      var k = slides.findIndex(function (s) { return s.dataset.mediaId === String(mediaId); });
      if (k > -1) go(k);
    };
    sync();
  }

  /* ---------- hero buy box ---------- */
  function initHero(root) {
    initGallery(root);
    var form = $('form.lv2-form', root);
    if (!form) return;
    var idInput = $('input[name="id"]', form);
    var packs = $$('.lv2-pack', root);
    var priceNow = $$('[data-lv-price]');
    var priceWas = $$('[data-lv-was]');
    var priceOff = $$('[data-lv-off]');
    var varName = $$('[data-lv-varname]');
    var atcBtns = $$('[data-lv-add]');
    var buyBtns = $$('[data-lv-buynow]');

    function apply(pack) {
      packs.forEach(function (p) { p.classList.toggle('is-active', p === pack); p.setAttribute('aria-checked', p === pack ? 'true' : 'false'); var i = $('input', p); if (i) i.checked = p === pack; });
      var d = pack.dataset;
      idInput.value = d.variantId;
      priceNow.forEach(function (e) { e.textContent = d.price; });
      priceWas.forEach(function (e) { e.textContent = d.compare || ''; e.hidden = !d.compare; });
      priceOff.forEach(function (e) { e.textContent = d.off || ''; e.hidden = !d.off; });
      varName.forEach(function (e) { e.textContent = d.title; });
      var avail = d.available === 'true';
      atcBtns.forEach(function (b) { b.disabled = !avail; b.dataset.label = b.dataset.label || b.textContent; b.textContent = avail ? b.dataset.label : 'Sold out'; });
      buyBtns.forEach(function (b) { b.disabled = !avail; });
      $$('form.lv2-follow input[name="id"]').forEach(function (i) { i.value = d.variantId; });
      $$('form.lv2-follow button[type=submit]').forEach(function (b) { b.disabled = !avail; });
      if (d.mediaId && root.__lv2Go) root.__lv2Go(d.mediaId);
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', d.variantId);
        window.history.replaceState({}, '', u.toString());
      } catch (e) {}
    }
    packs.forEach(function (p) {
      p.addEventListener('click', function (e) { e.preventDefault(); if (p.classList.contains('is-soldout')) return; apply(p); });
      p.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); p.click(); } });
    });

    // Add to cart / Buy now use the native form submit, exactly like the live PDP,
    // so GoKwik (side cart + checkout) intercepts them the same way.

    /* desktop: keep the buy box in view while the image grid scrolls */
    var info = $('.lv2-hero__info', root);
    if (info && window.matchMedia) {
      var mq = window.matchMedia('(min-width: 990px)');
      var setStick = function () {
        if (!mq.matches) { info.style.removeProperty('--lv-stick'); return; }
        var top = Math.min(80, window.innerHeight - info.offsetHeight - 16);
        info.style.setProperty('--lv-stick', top + 'px');
      };
      setStick();
      window.addEventListener('resize', setStick);
      if ('ResizeObserver' in window) new ResizeObserver(setStick).observe(info);
    }

    /* sticky bar */
    var sticky = $('.lv2-sticky', root);
    var anchor = $('.lv2-cta', root);
    if (sticky && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var below = en[0].boundingClientRect.top < 0;
        var on = !en[0].isIntersecting && below;
        sticky.classList.toggle('is-visible', on);
        document.documentElement.classList.toggle('lv2-sticky-on', on);
      }).observe(anchor);
    }
  }

  /* ---------- scroll-to-buy links ---------- */
  function initQuickAdd() {
    $$('[data-lv-scroll-buy]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        var t = document.querySelector('.lv2-hero');
        if (!t) return;
        e.preventDefault();
        t.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* ---------- before / after ---------- */
  function initBA() {
    $$('.lv2-ba').forEach(function (ba) {
      var r = $('input[type=range]', ba);
      if (!r) return;
      var set = function () { ba.style.setProperty('--pos', r.value + '%'); };
      r.addEventListener('input', set); set();
    });
  }

  /* ---------- tabs (routine + faq) ---------- */
  function initTabs() {
    $$('[data-lv-tabs]').forEach(function (wrap) {
      var tabs = $$('[role=tab]', wrap);
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          tabs.forEach(function (o) {
            var on = o === t;
            o.setAttribute('aria-selected', on ? 'true' : 'false');
            var p = document.getElementById(o.getAttribute('aria-controls'));
            if (p) p.hidden = !on;
          });
        });
      });
    });
  }

  /* ---------- rails ---------- */
  function initRails() {
    $$('[data-lv-rail]').forEach(function (wrap) {
      var rail = $('[data-lv-rail-track]', wrap);
      if (!rail) return;
      var step = function () { var c = rail.firstElementChild; return c ? c.getBoundingClientRect().width + 14 : 300; };
      var p = $('[data-lv-rail-prev]', wrap), n = $('[data-lv-rail-next]', wrap);
      if (p) p.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (n) n.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
      var cnt = $('[data-lv-count]', wrap), prog = $('[data-lv-progress]', wrap);
      if (cnt || prog) {
        var total = rail.children.length;
        var upd = function () {
          var i = Math.round(rail.scrollLeft / step());
          if (rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4) i = total - 1;
          i = Math.max(0, Math.min(total - 1, i));
          if (cnt) cnt.textContent = (i + 1 < 10 ? '0' : '') + (i + 1);
          if (prog) prog.style.transform = 'translateX(' + (i * 100) + '%)';
        };
        var tm; rail.addEventListener('scroll', function () { clearTimeout(tm); tm = setTimeout(upd, 60); }, { passive: true });
        upd();
      }
    });
  }

  function boot() {
    $$('.lv2-hero').forEach(initHero);
    initQuickAdd(); initBA(); initTabs(); initRails(); initReveal();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
